import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunitiesGivingCampaignsProps = {
  id: number;
};

export const keyCommunitiesGivingCampaigns: BaseKeyFunction<
  KeyCommunitiesGivingCampaignsProps
> = ({ id }) => ["communities-giving-campaigns", id.toString()];
